import { Carousel } from "@/components/organisms/Carousel/carousel"
import { CarouselNavigation } from "@/components/molecules/Carousel/carousel-navigation"
import { CarouselContent } from "@/components/organisms/Carousel/carousel-content"
import { CarouselItem } from "@/components/molecules/Carousel/carousel-item"
import FeaturedUserCard, { User } from "@/components/molecules/UserCard/featured"
import { HeadingText } from "@/components/atoms/HeadingText/heading-text"
import { getConsultants } from "@/actions/user/user.action"

export async function FeaturedConsultantsSection({ consultants, translations }: { consultants: any, translations: Record<string, any> }) {
  const res: any = await getConsultants(1)
  const items = res.data.data.items
  if (!items.length) return

  return (
    <section className="mx-auto max-w-screen-2xl px-5 pb-12">
      <Carousel opts={{ skipSnaps: true }}>
        <div className="flex justify-between py-10">
          <HeadingText level={2}>{translations.featured}</HeadingText>
          <div className="hidden gap-10 md:flex">
            <CarouselNavigation direction="prev" className="relative" />
            <CarouselNavigation direction="next" className="relative" />
          </div>
        </div>
        <CarouselContent>
          {items.map((profile: User, idx: number) => (
            <CarouselItem className="basis-1/1 md:basis-1/2 lg:basis-1/4" key={"featured_" + profile.id + idx}>
              <FeaturedUserCard profile={profile} />
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>
    </section>
  )
}
